export const calculateNoOfDays = (start_date, end_date) => {
	// Parse the input strings
	const [day1, month1, year1] = start_date.split('-').map(Number);
	const [day2, month2, year2] = end_date.split('-').map(Number);

	// Create Date objects (months are zero-indexed in JavaScript Date)
	const date1 = new Date(year1, month1 - 1, day1);
	const date2 = new Date(year2, month2 - 1, day2);

	// Calculate the difference in milliseconds
	const differenceInMilliseconds = date2 - date1;

	// Convert milliseconds to days and include both start and end dates
	const millisecondsPerDay = 24 * 60 * 60 * 1000;
	const differenceInDays = differenceInMilliseconds / millisecondsPerDay + 1;
	return differenceInDays > 0 ? differenceInDays : 0;
}

export const calculateMilestoneSteps = (stepsPerDay, noOfDays, employeeCount) => {
	let totalCount = stepsPerDay * noOfDays * employeeCount;

	if (totalCount > 1000000000) {
		return Math.floor(totalCount / 100000000) * 100000000;
	} else if (totalCount > 1000000) {
		return Math.floor(totalCount / 1000000) * 1000000;
	} else if (totalCount > 1000) {
		return Math.floor(totalCount / 1000) * 1000;
	} else {
		return totalCount;
	}
}
